import React, {
	useEffect, useState
}from "react"
import {
	 Modal, Form, Select
}from "antd"
import {
	useDispatch,
	useSelector
}from 'react-redux'
import CustomButton from "../../../components/CustomButton"
import CustomInput from "../../../components/CustomInput"
import Notifications from "../../../helpers/Notifications"
import {
	reOrgActions
}from "./store/actions"
import {
	useDebounce
}from "use-debounce"
import CustomSelect from "../../../components/CustomSelect"
import {
	reOrgStatusTypeActions
}from "../ReOrgStatusType/store/actions"
import {
	reOrgTypeActions
}from "../ReOrgType/store/actions"

const ChangeReOrg = ({ visible, setVisible, setRecord, record }) => {
	const [searchType, setSearchType] = useState('')
	const [searchStatus, setSearchStatus] = useState('')

	const { isSending, changed } = useSelector(state => state.reOrgReducer)
	const types = useSelector(state => state.reOrgTypeReducer.list)
	const statuses = useSelector(state => state.reOrgStatusTypeReducer.list)

	const [type] = useDebounce(searchType, 500)
	const [status] = useDebounce(searchStatus, 500)

	const [form] = Form.useForm()
	const dispatch = useDispatch()

	const update = (values) => {
		dispatch(reOrgActions.update(values))
	}
	const create = (values) => {
		dispatch(reOrgActions.create(values))
	}
	const getReOrgType = (values) => {
		dispatch(reOrgTypeActions.getList(values))
	}
	const getReOrgStatusType = (values) => {
		dispatch(reOrgStatusTypeActions.getList(values))
	}

	useEffect(() => {
		return () => {
			dispatch(reOrgActions.clear())
			dispatch(reOrgStatusTypeActions.clear())
			dispatch(reOrgTypeActions.clear())
		}
	}, [])

	useEffect(() => {
		form.resetFields()
		if (record){
			form.setFieldsValue({
				id        : record.id,
				unp       : record.unp,
				fullName  : record.fullName,
				shortName : record.shortName,
				type      : record.reOrgType.id,
				status    : record.reOrgStatusType.id
			})
		}
	}, [record])

	useEffect(() => {
		if (changed)
			handleCancel()
	}, [changed])

	useEffect(() => {
		getReOrgType({ name: type })
	}, [type])

	useEffect(() => {
		getReOrgStatusType({ name: status })
	}, [status])

	function handleCancel(){
		form.resetFields()
		setVisible(false)
		setRecord(null)
	}

	const save = () => {
		form.validateFields().then(values => {
			const updateValues = {
				id                : record?.id,
				unp               : values.unp?.trim(),
				fullName          : values.fullName?.trim(),
				shortName         : values.shortName?.trim(),
				reOrgTypeId       : values.type,
				reOrgStatusTypeId : values.status
			}
			const previousValues = {
				id                : record?.id,
				unp               : record?.unp,
				fullName          : record?.fullName,
				shortName         : record?.shortName,
				reOrgTypeId       : record?.reOrgType.id,
				reOrgStatusTypeId : record?.reOrgStatusType.id
			}
			if (JSON.stringify(updateValues) === JSON.stringify(previousValues))
				Notifications.errorNotice("Введенные вами данные полностью соответствуют изначальным.", null, 20)
			else
				record ? update(updateValues) : create(updateValues)
		})
	}

	return (
		<Modal
			destroyOnClose
			footer={ [
				<CustomButton
					key="save"
					loading={ isSending }
					type="green"
					onClick={ save }
				>
                    Сохранить
				</CustomButton>
			] }
			title={ record ? "Редактирование записи" : "Добавление записи" }
			visible={ visible }
			width={ 900 }
			onCancel={ handleCancel }
		>
			<Form
				form={ form }
				labelAlign="left"
				labelCol={ { span: 6 } }
				name="nsi-form"
				wrapperCol={ { span   : 16,
					offset : 1 } }
			>
				<Form.Item
					label="УНП"
					name="unp"
					rules={ [
						{
							required : true,
							message  : "УНП заполнен некорректно.",
							pattern  : /^\d{1,9}$/
						}
					] }
				>
					<CustomInput
						placeholder="Введите УНП"
						readOnly={ Boolean(record) }
					/>
				</Form.Item>
				<Form.Item
					label="Полное название"
					name="fullName"
					rules={ [
						{
							required   : true,
							whitespace : true,
							min        : 3
						}
					] }
				>
					<CustomInput
						placeholder="Введите полное название"
					/>
				</Form.Item>
				<Form.Item
					label="Сокращенное название"
					name="shortName"
					rules={ [
						{
							whitespace : true,
							min        : 3,
							max        : 200
						}
					] }
				>
					<CustomInput
						placeholder="Введите сокращенное название"
					/>
				</Form.Item>
				<Form.Item
					label="Тип"
					name="type"
					rules={ [{ required: true }] }
				>
					<CustomSelect
						allowClear
						showSearch
						filterOption={ false }
						notFoundContent={ null }
						placeholder="Выберите тип"
						onSearch={ value => setSearchType(value) }
					>
						{ types?.map(unit => {
							return (
								<Select.Option
									key={ unit.id }
									value={ unit.id }
								>
									{ unit.name }
								</Select.Option>)
						}) }
					</CustomSelect>
				</Form.Item>
				<Form.Item
					label="Статус"
					name="status"
					rules={ [{ required: true }] }
				>
					<CustomSelect
						allowClear
						showSearch
						filterOption={ false }
						notFoundContent={ null }
						placeholder="Выберите статус"
						onSearch={ value => setSearchStatus(value) }
					>
						{ statuses?.map(unit => {
							return (
								<Select.Option
									key={ unit.id }
									value={ unit.id }
								>
									{ unit.name }
								</Select.Option>)
						}) }
					</CustomSelect>
				</Form.Item>
			</Form>
		</Modal>
	)
}
export default ChangeReOrg
